var React = require('react');

function LoopInfinite (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"style":{"fill":"none","stroke":"#000000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10"},"d":"M10.5,10\r\n\t\tc0,0-1.5-3.5-4.5-3.5S0.5,8.963,0.5,12s2.462,5.5,5.5,5.5c5,0,7-11,12-11c3,0,5.5,2.463,5.5,5.5S21,17.5,18,17.5S13.5,15,13.5,15","key":0}),React.createElement("polyline",{"style":{"fill":"none","stroke":"#000000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10"},"points":"\r\n\t\t7.025,9.344 10.5,10 11.154,6.525 \t","key":1})]));
}

LoopInfinite.defaultProps = {"version":"1.0","id":"Outline_Icons","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = LoopInfinite;

LoopInfinite.default = LoopInfinite;
